// src/utils/request.js
import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
    baseURL: 'https://api.tiantai.cn',
    //  baseURL: 'http://192.168.10.104:6789',
    timeout: 10000 // 超时时间（ms）
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 如果有 token，这里可以统一携带
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // 可以在这里统一处理错误码
        if (res.code && res.code !== 200) {
            console.error('请求出错：', res.message)
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.error('网络异常：', error)
        return Promise.reject(error)
    }
)

// GET 请求
export function get(url, params = {}) {
  return service({
    url,
    method: 'get',
    params
  })
}

// POST 请求
export function post(url, data = {}) {
  return service({
    url,
    method: 'post',
    data
  })
}

